import m, {Vnode, VnodeDOM} from "mithril";
import h from "../../../../ui/design";
import Cell from "../../../../model/form/cell";
import {CheckboxItem} from "../../../../model/items/checkbox";
import {InputTextItem} from "../../../../model/items/inputText";
import {Questionary} from "../../../../model/questionary";

export default class CheckboxCell {

    public readonly checkbox!: CheckboxItem;
    private readonly inputText?: InputTextItem;
    private readonly questionary: Questionary;

    constructor(
        public readonly cell: Cell,
        private readonly setValue: ((cellItem: CheckboxItem, value: any)=>void)|null = null,
        private readonly onFinishInput: (()=>void)|null = null
    ) {
        this.questionary = cell.grid.questionary;

        for (const item of cell.cellItems) {
            if (item instanceof CheckboxItem) {
                this.checkbox = item;
            } else if (item instanceof InputTextItem) {
                this.inputText = item;
            }
        }

        if (!this.checkbox) {
            throw Error(`Expected checkbox in cell ${cell.id} missing.`);
        }
    }


    private viewInputTextText() {
        if (!this.inputText) {
            return null;
        }
        if (this.checkbox.getVariable()) {
            return m('input', {
                type: 'text',
                autocomplete: 'off',
                tabindex: 1,
                name: this.inputText.variableName,
                placeholder: this.cell.grid.form.questionary.renderText(this.inputText.text),
                onkeydown: (e: KeyboardEvent) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        if (this.onFinishInput) {
                            this.onFinishInput();
                        }
                    }
                },
                oninput: (e: KeyboardEvent) => {
                    const value = (<HTMLInputElement>e.currentTarget).value;
                    this.inputText!.setVariable(value);
                },
            });
        }

        return null;
    }

    private focusMe(): void {
        const $el = $(`input[name="${this.inputText!.variableName}"]`).focus();
        setTimeout(() => {
            if (window.screen.width >= h.BC.md) {
                return;
            }
            $el[0]?.scrollIntoView?.();
        }, 500); // due phone software keyboard, should be solved via onResize event
    }


    public view(): Vnode|null {

        if (!this.cell.visible) {
            return null;
        }

        const checked = Boolean(this.checkbox.getVariable());
        const cssClass = 'checkboxCell' + (this.cell.cssClass ? (' '+this.cell.cssClass) : '');

        return m("div", {
            "class": cssClass
        }, [
                m('label', {}, [
                m("input",
                    {
                        type: "checkbox",
                        tabindex: 1,
                        name: this.checkbox.variableName,
                        disabled: !this.cell.enabled,
                        onclick: () => {
                            const value = !this.checkbox.getVariable();
                            if (this.setValue) {
                                this.setValue(this.checkbox, value);
                            } else {
                                this.checkbox.set();
                            }
                            if (value && this.inputText) {
                                this.focusMe();
                            }
                        },
                        checked: checked,
                    },
                ),
                m("span"+(this.cell.enabled ? (checked ? h.backgroundSecondary : '') : h.backgroundDisabled ), {},
                    m('.option-label', m.trust(this.questionary.renderText(this.checkbox.childrenTags[0] ? (this.checkbox.childrenTags[0]?.value??'') : '✓'))),
                    this.viewInputTextText()
                )
            ])
        ]);
    }

    public oncreate(vnode: VnodeDOM): void {
        if (this.inputText) {
            $(vnode.dom).find('input[type="text"]').val(this.inputText.getVariable());
        }
    }

}